module.exports = __webpack_public_path__ + "img/xiaofengBanner.bad6961a.jpg";